var map = {
	"./AfterTick-C4.svg": [
		37241,
		7241
	],
	"./AfterTick-CG.svg": [
		6554,
		6554
	],
	"./AfterTick-J1.svg": [
		37347,
		7347
	],
	"./AfterTick-Q5.svg": [
		90978,
		978
	],
	"./AfterTick-SY.svg": [
		21996,
		1996
	],
	"./AfterTick-XC.svg": [
		45847,
		5847
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76621;
module.exports = webpackAsyncContext;